// extracted by mini-css-extract-plugin
module.exports = {"header":"finances_header__1hgJT","table":"finances_table___eGTu","section":"finances_section__WMXwt","sectionTitle":"finances_sectionTitle__1oh3A"};